import Fingerprint2 from "fingerprintjs2";

// let fingerprint = undefined;
const setFingerprint = () => {
  const defaultOptions = {
    preprocessor: null,
    audio: {
      timeout: 1000,
      // On iOS 11, audio context can only be used in response to user interaction.
      // We require users to explicitly enable audio fingerprinting on iOS 11.
      // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
      excludeIOS11: true
    },
    fonts: {
      swfContainerId: "fingerprintjs2",
      swfPath: "flash/compiled/FontList.swf",
      userDefinedFonts: [],
      extendedJsFonts: true
    },
    screen: {
      // To ensure consistent fingerprints when users rotate their mobile devices
      detectScreenOrientation: true
    },
    plugins: {
      sortPluginsFor: [/palemoon/i],
      excludeIE: false
    },
    extraComponents: [],
    excludes: {
      // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
      enumerateDevices: true,
      // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
      pixelRatio: true,
      // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
      doNotTrack: true,
      // uses js fonts already
      fontsFlash: true,

      // #### Browser independent components

      userAgent: true,
      //no (most of the time)
      language: true,
      // no (but not supported by IE)
      hardwareConcurrency: true,

      sessionStorage: true,
      localStorage: true,
      indexedDb: true,
      addBehavior: true,
      openDatabase: true,
      plugins: true,
      adBlock: true,
      fonts: true,
      audio: true,

      // exclude screen
      screenResolution: true,
      availableScreenResolution: true

      // (most of the time)
      //'canvas': true,
      //'webgl': true,
      //'fonts',
    },
    NOT_AVAILABLE: "not available",
    ERROR: "error",
    EXCLUDED: "excluded"
  };

  return new Promise(resolve => {
    Fingerprint2.get(defaultOptions, components => {
      var values = components.map(component => {
        return component.value;
      });
      const deviceprint = Fingerprint2.x64hash128(values.join(""), 31);
      resolve(deviceprint);
    });
  });
};

// if ((window as any).requestIdleCallback) {
//   (window as any).requestIdleCallback(setFingerprint);
// } else {
//   // setTimeout(setFingerprint, 0);
//   setFingerprint();
// }

export const getDeviceId = async () => {
  const id = await setFingerprint();
  // console.log(id);
  return id as string;
};
